import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
import { computed } from "vue";
import { fmtK } from "@/types/utils";
import { calculateCurrentPopulation, calculateFarmCapacity } from "@/utils/population";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarMobile',
  setup(__props) {

const fmtFull = new Intl.NumberFormat('en');

// computed
const activeVillage = computed(() => store.state.village.village);
const resources = computed<{
  food: number;
  mana: number;
  gold: number;
}>(() => {
  const resource = activeVillage.value?.resources;
  return {
    food: Math.max(0, resource?.food ?? 0),
    mana: Math.max(0, resource?.mana ?? 0),
    gold: Math.max(0, resource?.gold ?? 0),
  };
});
const currentPopulation = computed(() => calculateCurrentPopulation(activeVillage.value));
const farmCapacity = computed(() => calculateFarmCapacity(activeVillage.value));
const availablePopulation = computed(() => Math.max(0, farmCapacity.value - currentPopulation.value));
const hasMultipleVillages = computed<boolean>(
  () => store.state.user.villages && store.state.user.villages.length > 1,
);
const villageName = computed<string>(() => {
  if (activeVillage.value.name) {
    return store.state.user.client.toName(activeVillage.value.name);
  }

  const coords = activeVillage.value.position;
  if (!coords) return "??,??";

  return `X:${coords.x}, Y:${coords.y}`;
});
const sortedVillages = computed(() => {
  if (!store.state.user.villages) return [];
  // @ts-expect-error
  return store.state.user.villages.slice().sort((a, b) => {
    const nameA = store.state.user.client.toName(a.account.name);
    const nameB = store.state.user.client.toName(b.account.name);
    return nameA.localeCompare(nameB, undefined, {
      sensitivity: "base",
      numeric: true,
    });
  });
});

// methods
function switchVillage(direction: number) {
  const villages = sortedVillages.value;
  if (villages.length < 2) return;

  const activeKey = store.state.user.active_village;
  const currentIndex = villages.findIndex(
    (v: { publicKey: string }) =>
      v.publicKey.toString() === activeKey.toString(),
  );
  const nextIndex =
    (currentIndex + direction + villages.length) % villages.length;
  const village = villages[nextIndex];

  store.commit("user/set_active_village", village.publicKey);
  store.dispatch("village/refresh_village");
}

return { __sfc: true,fmtFull, activeVillage, resources, currentPopulation, farmCapacity, availablePopulation, hasMultipleVillages, villageName, sortedVillages, switchVillage, fmtK }
}

})